import { AnyAction } from 'redux';
import { compose } from 'redux';

export const POSTFIX = {
  request: '/REQUEST',
  success: '/SUCCESS',
  failure: '/FAILURE',
} as const;

function formOnSubmit(fun: (data: any) => AnyAction) {
  return (data: any, dispatch: (action: AnyAction) => void) => compose(dispatch, fun)(data);
}

function makeActionDefault(payload: any) {
  return { payload };
}

function makeActionCreator(type: string, makeAction = makeActionDefault) {
  const actionCreator = (arg: any) => ({ ...makeAction(arg), type });
  return Object.assign(actionCreator, { type });
}

export function syncAction<Payload = void>(base: string, makeAction: (arg: any) => any = makeActionDefault) {
  const creator = makeActionCreator(base, makeAction);
  return creator as {
    (payload: Payload): { type: string; payload: Payload };
    type: string;
  };
}

function createProps(base: string, postfix: typeof POSTFIX) {
  return (a: PropertyDescriptorMap, v: string) => {
    if (v in postfix) {
      return {
        ...a,
        [v]: {
          value: base + postfix[v as keyof typeof POSTFIX],
          enumerable: true,
        },
      };
    }
    return a;
  };
}

export function asyncAction<RequestPayload = void>(base: string, makeAction: (arg: any) => any = makeActionDefault) {
  const actionCreator = makeActionCreator(base, makeAction) as {
    (payload: RequestPayload): { type: string; payload: RequestPayload };
    type: string;
    onSubmit: (data: RequestPayload, dispatch: (action: AnyAction) => void) => void;
    request: string;
    success: string;
    failure: string;
  };

  const params = Object.keys(POSTFIX).reduce(createProps(base, POSTFIX), {
    onSubmit: {
      value: formOnSubmit(actionCreator),
      enumerable: true,
    },
  } as PropertyDescriptorMap);

  Object.defineProperties(actionCreator, params);

  return actionCreator;
}
